import type { File, Folder } from '@efdigital/ll-addon-data';
import { findFolderAndContents } from '@efdigital/ll-admin-v2/data/builders/content/files';
import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import { Request } from '@warp-drive/ember';

import FolderBreadcrumb, {
  FolderBreadcrumbItem,
} from './folder-breadcrumb.gts';
import { FolderContents } from './folder-contents.gts';
import { FileItem, FolderItem } from './folder-items.gts';

interface FileBrowserSignature {
  Element: HTMLDivElement;
  Args: {
    path: string;
    navigateToFolder: (path: string) => void;
    selectFile: (file: File) => void;
    selectFolder: (folder: Folder) => void;
  };
}

export default class FileBrowser extends Component<FileBrowserSignature> {
  get folderAndContents() {
    return findFolderAndContents(this.args.path);
  }

  <template>
    <Request @query={{this.folderAndContents}}>
      <:content as |response|>
        <FolderBreadcrumb @folderAndContents={{response.data}}>
          <:breadcrumb as |crumb|>
            <FolderBreadcrumbItem
              @crumb={{crumb}}
              @onClick={{fn @navigateToFolder crumb.id}}
            />
          </:breadcrumb>
        </FolderBreadcrumb>
        <FolderContents
          @folderAndContents={{response.data}}
          @containerClass="row row-cols-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-3"
        >
          <:folder as |folder|>
            <FolderItem
              @item={{folder}}
              @onClick={{@selectFolder}}
              class="h-100 text-secondary border-secondary"
            />
          </:folder>
          <:file as |file|>
            <FileItem
              @item={{file}}
              @onClick={{@selectFile}}
              class="h-100 text-secondary border-secondary"
            />
          </:file>
        </FolderContents>
      </:content>
      <:loading>
        <div class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </:loading>
      <:error as |error|>
        <div class="text-center py-5">
          <p class="text-danger">Error loading folder: {{error.message}}</p>
        </div>
      </:error>
    </Request>
  </template>
}
